import {useEffect, useState} from "react";
import {Input, Toast} from "antd-mobile";
import {buryingPoint, checkPetitionSign, queryPetition} from "../apis/httpInterface";
import {generateBuryingPointData} from "../utils/Tools";

const petition = () => {
    const [userName, setUserName] = useState<string>('--')
    const [cid, setCid] = useState<number | null>(null);
    const [value, setValue] = useState('');
    const [fileUrl, setFileUrl] = useState<string | null>(null);

    useEffect(() => {
        document.title = '起诉状'
        const cidParam = window.location.search.slice(1)
        if (cidParam) {
            setCid(parseInt(cidParam));
        }
        return () => {
            document.title = '重庆市西部商事调解中心'
        }
    }, [])
    useEffect(() => {
        if (cid) {
            sumbitBuryingPoint("petition_homePage", "")
            Toast.show({icon: 'loading', content: '加载中....', duration: 0})
            queryPetition(cid).then(r => {
                Toast.clear()
                if (r.data) {
                    setUserName(r.data.orderNo)
                    setFileUrl(r.data.path)
                } else {
                    setFileUrl(null)
                    Toast.show({icon: "fail", content: '查询失败'})
                }
            }).catch(err => {
                setFileUrl(null)
                Toast.clear()
                Toast.show({icon: "fail", content: '查询失败'})
            })
        }
    }, [cid]);

    const sumbitBuryingPoint = (event: string, label: string) => {
        buryingPoint(generateBuryingPointData(event, label, cid ? cid : 0)).then(r => {}).catch(err => {console.error(err)})
    }
    const inputOnChange = (value: string) => {
        setValue(value)
    }
    const sumbitAction = () => {
        if (value.length <= 0) {
            Toast.show({icon: "fail", content: '请输入身份证后六位!'})
            return;
        }
        sumbitBuryingPoint("petition_sumbit", "")
        //上报数据
        const data = {
            id: cid,
            idCard: value
        }
        Toast.show({icon: 'loading', content: '加载中....', duration: 0})
        checkPetitionSign(data).then((r:any) => {
            Toast.clear()
            if (r.executed) {
                if (fileUrl) {
                    shareOrOpenPdf(fileUrl)
                } else {
                    Toast.show({icon: "fail", content: '起诉状未生成'})
                }
            } else {
                Toast.show({icon: "fail", content: r.message})
            }
        }).catch(err => {
            Toast.clear()
            Toast.show({icon: "fail", content: '查询失败'})
        })
    }
    const shareOrOpenPdf = (url: string) => {
        const a = document.createElement('a');
        a.href = url;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    return (
        <div className={'letterRoot'}>
            <span style={{marginTop: 150, fontSize: 24, fontWeight: "bold", color: '#b61c0f'}}>起诉状</span>
            <div className={'detail-box'}>
                <div className={'top-box'}>
                    <span style={{fontSize: 18, fontWeight: "bold", color: '#0A0A0A'}}>您好！</span>
                    <span style={{fontSize: 14, fontWeight: 400, color: '#666666', marginTop: 10}}>请输入<span
                        style={{color: '#A81213'}}>身份证后六位</span>查看您的起诉状</span>
                </div>
                <div className={'name-box'}>
                    <span className={'common-title'}>姓名</span>
                    <span className={'common-title'}>{userName}</span>
                </div>
                <div className={'idcard-box'}>
                    <span className={'common-title'}>身份证后六位</span>
                    <Input onChange={inputOnChange} style={{width: '30%'}} placeholder={'请输入身份证后六位'}/>
                </div>
            </div>
            <div onClick={sumbitAction} className={'submit-box'}>查看</div>
            <div className={'bottom-box'}>
                如有疑问<br/>重庆市西部商事调解中心:023-65795700
            </div>
        </div>
    )
}
export default petition
